module.exports = __webpack_public_path__ + "img/ic_instagram.2ff60cb1.png";